module.exports = __webpack_public_path__ + "img/Gerätewagen_Sanität.68c6abfe.svg";